<template>
    <button
        :disabled="disabled || form.busy"
        :type="type ? type : 'button'"
        class="button"
        :class="classNames"
    >
        <slot></slot>
    </button>
</template>

<script>
import { getCurrentInstance } from 'vue';

export default {
    props: {
        type: { type: String, default: 'submit' },
        form: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
        enableLoading: { type: Boolean, default: true },
    },

    computed: {
        classNames() {
            const instance = getCurrentInstance();
            let classes = [];

            if (instance.data.class) {
                classes.push(instance.data.class);
            }

            if (this.enableLoading && this.form.busy) {
                classes.push('is-busy');
            }

            return classes.join(' ');
        },
    },
};
</script>
